import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, ButtonGroup, Table } from "reactstrap";

import { IoAdd } from "react-icons/io5";
import swal from "sweetalert";
import { LoadingSpinner, isUrdu } from "../../../../constants/const";
import { GetLanguageString, NoResult } from "../../../helper/Components";
import { GetCustomStyles, GetSelectedLanguage } from "../../../helper/Method";
import AddExpenseHead from "./AddExpenseHead";
import EditExpenseHead from "./EditExpenseHead";
import { ApiFinance } from "../ApiFinance";

const ExpenseHeads = ({ activeTab }) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [expenseHeads, setExpenseHeads] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [editValues, setEditValues] = useState();

  useEffect(() => {
    if (activeTab === "expenseHeads") {
      setLoading(true);
      ApiFinance()
        .GetFinanceExpenseHeadsList()
        .then((res) => {
          setExpenseHeads(res.data);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  }, [activeTab, reload]);

  const handleOnDelete = (value) => {
    swal({
      title: t("common_delete_message"),
      text: t("common_delete_detail_message"),
      icon: "warning",
      buttons: true,
      className: GetSelectedLanguage() === "en" ? "" : "ur",
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoading(true);
        ApiFinance()
          .DeleteExpenseHead(value)
          .then((res) => {
            swal({
              title: t("finance_expense_head_deleted"),
              className: GetSelectedLanguage() === "en" ? "" : "ur",
              icon: "success",
              buttons: "OK",
            });
            setReload(!reload);
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: err,
              icon: "error",
              buttons: "OK",
            });
            setLoading(false);
          });
      }
    });
  };

  const handleOnEdit = (e) => {
    setEditValues(e);
    setEditModal(true);
  };

  return (
    <div>
      {editModal ? (
        <EditExpenseHead
          expenseHeadValues={editValues}
          setEditModal={setEditModal}
          setReload={setReload}
          reload={reload}
        />
      ) : null}
      {addModal ? (
        <AddExpenseHead
          setAddModal={setAddModal}
          setReload={setReload}
          reload={reload}
        />
      ) : null}
      <div className="ibox ">
        <div className="ibox-title">
          <h5>
            <GetLanguageString props="finance_tab_expense_heads" />
          </h5>
          <Button
            color="white"
            size="sm"
            className={GetCustomStyles().btn_style}
            onClick={() => {
              setAddModal(true);
            }}
          >
            <IoAdd
              size={18}
              color="#18A689"
              style={{ marginRight: 3, marginBottom: 1 }}
            />
            {<GetLanguageString props="finance_tab_expense_heads_add" />}
          </Button>
        </div>
        <div className="ibox-content">
          {!loading ? (
            expenseHeads.length !== 0 ? (
              <div className="table-responsive">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>{<GetLanguageString props="settings_title" />}</th>
                      <th>
                        {<GetLanguageString props="common_description" />}
                      </th>
                      <th>
                        {<GetLanguageString props="finance_tab_expense_head" />}
                      </th>
                      <th className="text-right">
                        {<GetLanguageString props="common_action" />}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {expenseHeads.map((record, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td className={isUrdu(record.title) ? "ur" : ""}>
                            {record.title}
                          </td>
                          <td
                            className={isUrdu(record.description) ? "ur" : ""}
                          >
                            {record.description}
                          </td>
                          <td
                            className={isUrdu(record.head?.label) ? "ur" : ""}
                          >
                            {record.head?.label}
                          </td>
                          <td className="text-right">
                            <ButtonGroup>
                              <Button
                                color="white"
                                size="sm"
                                onClick={() => handleOnEdit(record)}
                              >
                                {<GetLanguageString props="common_edit" />}
                              </Button>
                              <Button
                                color="white"
                                size="sm"
                                onClick={() => handleOnDelete(record.id)}
                              >
                                {<GetLanguageString props="common_delete" />}
                              </Button>
                            </ButtonGroup>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            ) : (
              <NoResult />
            )
          ) : (
            LoadingSpinner()
          )}
        </div>
      </div>
    </div>
  );
};

export default ExpenseHeads;
